import UserContactInfoLayout from './UserContactInfoLayout'

export default UserContactInfoLayout
